// extracted by mini-css-extract-plugin
export default {"header":"xO","container":"yO","accordeonitem":"zO","itemsticky":"AO","itemopen":"BO","open":"CO","productname":"EO","productinfo":"FO","flavorstext":"GO","invalidlimit":"HO","limit":"IO","scrollUpAccordion":"JO","wrapper":"KO"};
    if(module.hot) {
      // 1715276859127
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  